// extracted by mini-css-extract-plugin
export default {"SaveFiltersItems":"save-filters-settings_SaveFiltersItems__-e-Jl","buttonsBlock":"save-filters-settings_buttonsBlock__yeyW4","Message":"save-filters-settings_Message__GzGYO"};